import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=5e79ec28&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"
import style0 from "./Reportes.vue?vue&type=style&index=0&id=5e79ec28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79ec28",
  null
  
)

export default component.exports